export const ActionConfigTabIds = {
  EDIT: 'edit',
  CONNECTIONS: 'connections',
  DELAYED_OBJECTS: 'delayed-objects'
};